import {
  ChartOldWidgetKey,
  ChartWidgetKey,
  MapWidgetKey,
  MidstreamChartOldWidgetKey,
  MidstreamChartWidgetKey,
  MultiphaseChartWidgetKey,
  SamRfPvWidgetKey,
  SamWidgetKey
} from "./widgets.constants";

const DASHBOARD_SCREENSHOTTABLE_WIDGET_TYPES = new Set([
  MapWidgetKey,
  ChartWidgetKey,
  ChartOldWidgetKey,
  MultiphaseChartWidgetKey,
  MidstreamChartWidgetKey,
  MidstreamChartOldWidgetKey,
  SamWidgetKey,
  SamRfPvWidgetKey
]);

export function isDashboardScreenshottable(widgets: { component: string }[]): boolean {
  if (widgets.length === 0) return false;
  return widgets.every((w) => DASHBOARD_SCREENSHOTTABLE_WIDGET_TYPES.has(w.component));
}
